import * as actionType from "./action";

export function accountReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ACCOUNT_SUCCESS:
      return { ...state, response };
    case actionType.GET_ACCOUNT_ERROR:
      return { ...state, response };
    case actionType.ADD_ACCOUNT_SUCCESS:
      return state;
    case actionType.ADD_ACCOUNT_ERROR:
      return { ...state, response };
    case actionType.MODIFY_ACCOUNT_SUCCESS:
      return state;
    case actionType.MODIFY_ACCOUNT_ERROR:
      return { ...state, response };
    case actionType.DELETE_ACCOUNT_SUCCESS:
      return state;
    case actionType.DELETE_ACCOUNT_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function accountsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ACCOUNTS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ACCOUNTS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function currentUserAccountOwnerReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_CURRENT_USER_ACCOUNT_OWNER_SUCCESS:
      return { ...state, response };
    case actionType.GET_CURRENT_USER_ACCOUNT_OWNER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
